module.exports = __webpack_public_path__ + "img/coupon2022@2x.bf01517b.jpg";